import React from 'react'
import styled from 'styled-components'
import ImageContainer from 'views/Home/components/ImageContainer'
import ManWithWolfHead from '../../../components/Svg/ManWithWolfHead'
import SmallMoney from '../../../components/Svg/SmallMoney'
import YellowCircleSticker from '../../../components/Svg/YellowCircleSticker'
import Pen from '../../../components/Svg/Pen'
import Ellipse from '../../../components/Svg/Ellipse'

const Triangle = () => (
  <svg width="66" height="39" viewBox="0 0 66 39" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M35.4329 35.8056L5.00807 2.26901L61.5575 2.87558L35.4329 35.8056Z" stroke="white" strokeWidth="4" />
  </svg>
)

const RedTriangle = () => (
  <svg width="66" height="78" viewBox="0 0 66 78" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M30.381 78L0 31.5994L66 0L30.381 78Z" fill="#DE523E" />
  </svg>
)

const IsoscelesRedTriangle = () => (
  <svg width="127" height="114" viewBox="0 0 127 114" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M65.9122 0L127 86L0 114L65.9122 0Z" fill="#DE523E" />
  </svg>
)

export default function BackgroundWrapper() {
  return (
    <>
      <ImageContainer bottom="-300px" right="-671px" zindex="-2">
        <ManWithWolfHead width="857" height="741" />
      </ImageContainer>
      <ImageContainer top="65px" right="-361px" zindex="-3" rotate="rotate(-90deg)">
        <YellowCircleSticker />
      </ImageContainer>
      <ImageContainer bottom="-260px" left="-350px" zindex="-2">
        <SmallMoney width="384" height="340" viewBox="0 0 384 340" />
      </ImageContainer>
      <ImageContainer bottom="-200px" right="-671px" zindex="-1">
        <Pen />
      </ImageContainer>
      <ImageContainer bottom="-140px" right="-470px" zindex="-1">
        <Ellipse width="29" height="29" viewBox="0 0 29 29" cx="14.5" cy="14.5" r="12.5" />
      </ImageContainer>
      <ImageContainer top="170px" right="-370px" zindex="-2">
        <Triangle />
      </ImageContainer>
      <ImageContainer bottom="50px" left="-350px" zindex="-2">
        <RedTriangle />
      </ImageContainer>
      <ImageContainer top="250px" right="-670px" zindex="-4">
        <IsoscelesRedTriangle />
      </ImageContainer>
    </>
  )
}
